export const ChangeFavicon = (icon) => {
    let link = document.querySelector("link[rel*='icon']");

    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
    }

    link.type = "image/png";
    link.href = icon;
};